export default __webpack_public_path__ + "static/media/camera.d1de3678.svg";